import { criticalityConfig } from '@cobliteam/hooks/src/useAiRecommendationsStore/useAiRecommendationsStore';
import Tag from '@cobliteam/ui/components/Tag';
import Icon from '@cobliteam/ui/icons';

interface CriticalityTagProps {
  criticality: string;
}

const defaultConfig = { label: '', color: 'default', icon: 'info' };

const CriticalityTag = ({ criticality }: CriticalityTagProps) => {
  const config = criticalityConfig[criticality] ?? defaultConfig;

  if (criticality === 'critical') {
    return <Tag label={config.label} color='danger' variant='surface' size='sm' icon={<Icon name='octagon-alert' size='xs' color='danger' />} />;
  }

  if (criticality === 'urgent') {
    return <Tag label={config.label} color='warning' variant='surface' size='sm' icon={<Icon name='triangle-alert' size='xs' color='warning' />} />;
  }

  if (criticality === 'important') {
    return <Tag label={config.label} color='primary' variant='surface' size='sm' icon={<Icon name='circle-alert' size='xs' color='primary' />} />;
  }

  return <Tag label={config.label || criticality} color='success' variant='surface' size='sm' icon={<Icon name='circle-fading-plus' size='xs' color='success' />} />;
};

export default CriticalityTag;
